import { Injectable } from '@angular/core';
import { StateService } from '@uirouter/angular';
import { CourseTrack } from '../shared/models';

@Injectable({ providedIn: 'root' })
export class AcademyNavigationService {
  constructor(private stateService: StateService) {}

  goToReportCard(courseTrack: Pick<CourseTrack, 'id' | 'learning_track_id'>): void {
    const options = { location: 'replace' as const };
    if (courseTrack.learning_track_id) {
      this.stateService.go('learning-track-report-card', {
        learningTrackId: courseTrack.learning_track_id,
        courseTrackId: courseTrack.id,
      }, options);
    } else {
      this.stateService.go('report-card', { trackId: courseTrack.id }, options);
    }
  }

  goToLesson(
    courseTrack: Pick<CourseTrack, 'id' | 'learning_track_id'>,
    lessonSlug: string,
    options?: { replace?: boolean },
  ): void {
    const state = courseTrack.learning_track_id ? 'learning-track-course' : 'track-course';
    const params = courseTrack.learning_track_id
      ? {
        learningTrackId: courseTrack.learning_track_id,
        courseTrackId: courseTrack.id,
        lessonId: lessonSlug,
      }
      : { trackId: courseTrack.id, courseId: lessonSlug };

    if (options?.replace) {
      this.stateService.go(state, params, { location: 'replace' });
    } else {
      this.stateService.go(state, params);
    }
  }

  goToCourse(learningTrackId: number, courseTrackId: number): void {
    this.stateService.go('learning-track-course', { learningTrackId, courseTrackId });
  }

  goToNextCourse(courseTrack: Pick<CourseTrack, 'learning_track_id' | 'next_course_track_id'>): void {
    if (!courseTrack?.next_course_track_id) return;

    if (courseTrack.learning_track_id) {
      // lessonId/preloadedCourseTrack must be nulled explicitly, or UI-Router
      // inherits the stale values left over from viewing a non-first lesson,
      // and the target state's resolver short-circuits on the stale course (UT-3183).
      this.stateService.go('learning-track-course', {
        learningTrackId: courseTrack.learning_track_id,
        courseTrackId: courseTrack.next_course_track_id,
        lessonId: null,
        preloadedCourseTrack: null,
      });
    } else {
      this.stateService.go('tracks', { trackId: courseTrack.next_course_track_id });
    }
  }

  goToAcademyHome(): void {
    this.stateService.go('academy-home');
  }

  goToQuiz(courseTrack: Pick<CourseTrack, 'id' | 'learning_track_id'>): void {
    if (courseTrack.learning_track_id) {
      this.stateService.go('learning-track-quiz', {
        learningTrackId: courseTrack.learning_track_id,
        courseTrackId: courseTrack.id,
      });
    } else {
      this.stateService.go('quiz', { trackId: courseTrack.id });
    }
  }

  goToCertificationDetail(certificationId: number): void {
    this.stateService.go('academy-certification-detail', { certificationId });
  }

  goToCertifications(): void {
    this.stateService.go('academy-certifications');
  }
}
